<template>
  <NuxtLayout
    name="generic"
    :header="data?.header"
    :footer="data?.footer"
    :page-title="data?.title"
  >
    <div v-if="data">
      <MicroSiteHeroContent
        v-if="data.MicroSiteHeroContent"
        :micro-site-hero="data.MicroSiteHeroContent"
      />
      <SectionBuilder
        v-if="data.content"
        v-bind="data.content"
        :class="{
          'text-www-color-neutral-medium-dark': true,
        }"
      />

      <CtaBannerComponent
        v-if="data.CTABanner?.reference"
        :data="data.CTABanner.reference"
      />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import type { MicroSiteQueryResult } from '~/sanity/types';
import MicroSiteHeroContent from '~/components/Atmos/MicroSiteHeroContent/MicroSiteHeroContent.vue';
import CtaBannerComponent from '~/components/Organisms/CTABanner/CTABanner.vue';
import { microSiteQuery } from '~/queries/pages/PageMicrosite.query';
import SectionBuilder from '~/components/Atmos/SectionBuilder/SectionBuilder.vue';
import { extractAbstractFromSectionBuilder } from '~/utils/extractBreakoutSummary';
const { path: currentPathname } = useRoute();
const { data } = await useWwwSanityQueryNonNull<MicroSiteQueryResult>(microSiteQuery, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage:
    data.value?.ogImage?.asset ||
    data.value?.cardImage?.asset ||
    data.value?.genericCardImage?.asset,
  title: data.value?.htmlTitle || data.value?.title,
  twitterCard: 'summary',
  structuredData: [
    {
      schemaType: 'CreativeWork',
      title: data.value?.htmlTitle || data.value?.title,
      description: data.value?.ogDescription || data.value?.description,
      abstract: extractAbstractFromSectionBuilder(data.value?.content),
      enabled: true,
    },
  ],
});
</script>
